export default __webpack_public_path__ + "static/media/medium-png.fac3f166.png";